
<template>
   <v-dialog
      v-model="showHelp"
      max-width="600"
    >
      <v-card class="pb-3 mb-0">
        <v-toolbar color="green darken-3" dark>
          <v-toolbar-title class="headline">About Room Attribute Search</v-toolbar-title>
        </v-toolbar>

        <v-card-text class="ml-2 pr-4 mt-3">
          Room Collections is used to make Collections of rooms.  Each user owns and manages access to the collections they create. Collections can be named and custom colored.<br>

          Collections are organized into Collection Groups<br><br>

          <div class="px-5">
          <v-icon class="mr-2" style="position: relative; top: 3px;">share</v-icon>Collaborate by sending a link or
          assigning Viewers and Editors<br><br>
          <v-icon class="mr-2" style="position: relative; top: 3px;">control_camera</v-icon>Display Collection or Collection Group on map<br><br>
          <v-icon class="mr-2" style="position: relative; top: 3px;">color_lens</v-icon>Change Collection Color<br><br>          
          
          Clone : Copy the Collection or Group and become owner of a new copy<br><br>

          </div>
          
          Collections and Collection Groups can be Re-Ordered<br>
          Collections and Collection Groups can be exported to .xlsx

        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-layout align-items-center>
            <v-btn color="green darken-1"
              flat="flat"
              @click="setShowHelpRoomAttributeSearch(false)"
            > OK
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'HelpRoomCollections',

  computed: {
      showHelp: {
          get () { return this.$store.state.ui.showHelpRoomAttributeSearch },
          set (value) { this.setShowHelpRoomAttributeSearch(false) }
      },
  },
  
  methods : {
      ...mapMutations(['setShowHelpRoomAttributeSearch',]),
  },
}

</script>





// WEBPACK FOOTER //
// src/components/help/HelpRoomCollections.vue